/**
 * EthosBeads — production ETHOS bead system built from the high-fidelity
 * shungite (glossy black) + amethyst (translucent violet) bracelet master art.
 *
 *   • BeadInfinity        → login/welcome splash + Ritual Chamber enter/return
 *   • BeadTypingIndicator → chat "typing" indicator (three miniature ETHOS beads)
 *
 * Lightweight WebP (with PNG fallback) + CSS animation only. No video, no libs.
 * Animations live in index.css and are disabled under prefers-reduced-motion.
 */
const BRAND = `${process.env.PUBLIC_URL || ""}/assets/brand`;

/**
 * BeadInfinity — the ETHOS infinity bracelet emblem.
 * @param {number} size  width in px (height auto, ~0.44×)
 * @param {"breathe"|"login"|"chamber"} animate
 */
export function BeadInfinity({ size = 160, animate = "breathe", variant = "light", className = "", style = {} }) {
  const cls =
    animate === "chamber" ? "eb-float" :
    animate === "login" ? "eb-login" :
    animate === "none" ? "" :
    "eb-breathe";
  const file = variant === "dark" ? "ethos-beads-infinity-night" : "ethos-beads-infinity-v2";
  return (
    <picture>
      <source srcSet={`${BRAND}/${file}.webp`} type="image/webp" />
      <img
        src={`${BRAND}/${file}.png`}
        alt=""
        aria-hidden="true"
        className={`${cls} ${className}`}
        style={{ width: size, height: "auto", display: "block", willChange: "transform, filter", ...style }}
      />
    </picture>
  );
}

/**
 * BeadTypingIndicator — three miniature ETHOS beads (shungite · amethyst · shungite)
 * breathing in sequence. Small, subtle, readable.
 */
export function BeadTypingIndicator({ size = 10, className = "" }) {
  const beads = ["ethos-bead-shungite", "ethos-bead-amethyst", "ethos-bead-shungite"];
  return (
    <span
      className={`inline-flex items-end gap-[3px] ${className}`}
      style={{ verticalAlign: "middle" }}
      aria-hidden="true"
    >
      {beads.map((n, i) => (
        <picture key={i}>
          <source srcSet={`${BRAND}/${n}.webp`} type="image/webp" />
          <img
            src={`${BRAND}/${n}.png`}
            alt=""
            className="eb-tipbead"
            style={{ height: size, width: "auto", display: "block", animationDelay: `${i * 0.16}s` }}
          />
        </picture>
      ))}
    </span>
  );
}
